import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveCommunity,
  CommunityImageUpload,
  createCommunity,
  deleteCommunity,
  getAllActiveCommunities,
  getAllCommunities,
  getCommunityByID,
  updateCommunity,
} from "./services/community.services";
import { ICommunity, ICommunityState } from "./communityModel";

const initialState: ICommunityState = {
  loading: false,
  error: "",
  CommunityID: null,
  CommunityList: [],
  CommunityDetail: {
    PersonName: "",
    TourID: null,
    Title: "",
    InstaProfile: "",
    LongDescription: "",
    ShortDescription: "",
    Date: "",
    ActivityIDs: "",
    Description: "",
    FacebookProfile: "",
    LinkedInProfile: "",
    TwitterProfile: "",
    WebsiteProfile: "",
    TotalSeats: null,
    GroupSize: null,
    IsActive: 1,
  },
};

const communitySlice = createSlice({
  name: "community",
  initialState,
  reducers: {
    clearCommunityDetails: (state) => {
      state.CommunityDetail = initialState.CommunityDetail;
    },
    setCommunityID: (state, action) => {
      state.CommunityID = action.payload;
    },
    clearCommunityID: (state) => {
      state.CommunityID = initialState.CommunityID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCommunities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCommunities.fulfilled,
      (state, action: PayloadAction<ICommunity[]>) => {
        state.loading = false;
        state.CommunityList = action.payload || [];
      }
    );
    builder.addCase(getAllCommunities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CommunityList = [];
    });
    builder.addCase(createCommunity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createCommunity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createCommunity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCommunity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateCommunity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateCommunity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCommunity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCommunity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCommunity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCommunityByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCommunityByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CommunityDetail = action.payload;
    });
    builder.addCase(getCommunityByID.rejected, (state, action) => {
      state.loading = false;
      state.CommunityDetail = initialState.CommunityDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCommunities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCommunities.fulfilled,
      (state, action: PayloadAction<ICommunity[]>) => {
        state.loading = false;
        state.CommunityList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCommunities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CommunityList = [];
    });
    builder.addCase(ActiveInactiveCommunity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveCommunity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveCommunity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(CommunityImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(CommunityImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(CommunityImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCommunityDetails, clearCommunityID, setCommunityID } =
  communitySlice.actions;
export default communitySlice.reducer;
